<template>
  <div class="submit-cv container">
    <div class="content">
      <h2>{{ $t('footer.cv.title') }}</h2>
      <p class="body-2">
        {{ $t('footer.cv.content') }}
      </p>
    </div>
    <div class="button-container">
      <button
        class="button cta"
        @clicked="handlePress"
      >
        {{ $t('footer.cv.button.label') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { locale, t } = useI18n()
  const { push: routerPush } = useRouter()

  const handlePress = () => {
    GTM.pressSubmitCv()
    routerPush(`/${locale.value}/${t('talentPool.code')}`)
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .submit-cv.container {
    border-radius: 8px;
    color: $ui-dark-blue;
    margin: 0 auto;
    padding: rem(40);
    text-align: center;

    .content {
      margin-bottom: rem(24);

      @include tablet-up {
        margin: 0;
      }

      h2 {
        font-weight: 500;
        font-size: rem(24);
        line-height: rem(40);
      }

      h2,
      p {
        margin: 0 0 rem(24);
      }
    }

    .button {
      align-items: center;
      border: 1px solid $ui-dark-blue;
      border-radius: 4px;
      cursor: pointer;
      width: auto;
      padding: rem(16) rem(32);
      text-align: center;
      box-sizing: border-box;
      background-color: $white;
      color: $ui-dark-blue;
    }
  }
</style>
